<template>
  <div class="page-wrapper">
    <search-list class="mb16"
                @getdata="getData"

    ></search-list>
    <Button class="mb16" type="primary"
            :loading="buttonloading"
            @click.stop="downloadCheckinRateList"
            v-p="{menu:'checkinrate',api:'report/downloadCheckinRateList'}"
    >导出</Button>
    <table-list
      title="" :columns="columns" :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
      class = "report"
    ></table-list>
  </div>
</template>
<script>
  import SearchList from '../components/SearchList'
  import TableList from "components/TableList/index";
  import {checkinRateList} from "../../../api/reporter";
  import {getProjects} from "../../../api/common";
  import {formatDateTime} from "../../../utils/format";
  import subTable from './components/SubTable'
  import {downloadCheckinRateList} from "../../../api/reporter";

  export default {
    name: "checkinrate",
    components: {
      SearchList,
      TableList,
      subTable
    },
    created() {
      // this.init()
    },
    data() {
      return {
        currentData: 'days7',
        loading: false,
        totalDay7: 0,
        current: 1,
        total: 0,
        data: [],
        checkinList: [],
        searchData: null,
        columns: [],
        page:1,
        buttonloading:false
      }
    },
    methods: {
      downloadCheckinRateList(){
        if(!this.searchData){
          return
        }
        this.buttonloading=true;
        downloadCheckinRateList(this.searchData).then(res=>{
          let fileName = res.headers.filename || 'excel.xls';
          let blob = new Blob([res.data]);

          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.buttonloading=false

        }).catch(error=>{}).finally(()=>{
          this.buttonloading=false
        })

      },
      getData(params){
        this.current=1;
        this.page=1;
        // console.log(params)
        this.searchData=params;
        this.currentData=params.current;
        this.checkinRateList()

      },
      setColumns(){
        let columns = [
          {
            width:50,
            type: 'expand',
            title:' ',
            render:(h,params)=>{
              return h(subTable,{
                props:{
                  columns:this.columns,
                  params:{
                    "endTime": this.searchData.endTime,
                    "projectFids": [
                      params.row.projectFid
                    ],
                    "startTime": this.searchData.startTime,
                    "type": this.searchData.type
                  },
                  currentData:this.currentData
                }

              })
            }
          },
          {
            title: '项目名称',
            key: 'projectName',
            align: 'center',
            width:170,
          },
          // {title:' '},
        ];

        if (['days7','days30','byself'].indexOf(this.currentData) !== -1) {
          this.checkinList[0].info.forEach((ele, index) => {
            columns.push({
              title: ele.dateTime,
              align: 'center',
              children: [

                {
                  title: '入住率',
                  key: 'checkinRate' + index,
                  align: 'center',
                  width: 100,
                  render:(h,params)=>{
                    return h('span',{},(params.row['checkinRate'+index]*100).toFixed(2)+'%')
                  }
                },
                // {
                //   title: ' '
                // },
                {
                  title: '库存',
                  key: 'stock' + index,
                  align: 'center',
                  width: 100
                },
                // {
                //   title: ' '
                // },
                {
                  title: '已出租',
                  key: 'rented' + index,
                  align: 'center',
                  width: 100
                },
              ]
            })
            // columns.push({title:' '})
          });
          columns.push({title:' '});
          this.columns = columns
        }

        if(['byweek','bymonth'].indexOf(this.currentData) !== -1){
          this.checkinList[0].info.forEach((ele, index) => {
            columns.push({
              title: ele.dateTime,
              align: 'center',
              key:'checkinRate'+index,
              render:(h,params)=>{
                return h('span',{},(params.row['checkinRate'+index]*100).toFixed(2)+'%')
              },
              width:150
            });
            columns.push({title:' '})
          });
          this.columns = columns
        }
      },
      setData(){
        let data = [];
        if (['days7','days30','byself'].indexOf(this.currentData) !== -1) {

          this.checkinList.forEach((ele)=>{
            let d={};
            if(!ele.projectFid){
              d['_disableExpand']=true
            }
            d['projectFid']=ele.projectFid;
            d['projectName']=ele.projectName;
            ele.info.forEach((ele1,index1)=>{
              d['checkinRate' + index1]=ele1.checkinRate.value;
              d['rented' + index1]=ele1.rented.quantity;
              d['stock' + index1]=ele1.stock.quantity
            });
            data.push(d)
          });
          this.data=data
        }

        if(['byweek','bymonth'].indexOf(this.currentData) !== -1){


          this.checkinList.forEach((ele)=>{
            let d={};
            if(!ele.projectFid){
              d['_disableExpand']=true
            }
            d['projectFid']=ele.projectFid;
            d['projectName']=ele.projectName;
            ele.info.forEach((ele1,index1)=>{
              d['checkinRate' + index1]=ele1.checkinRate.value
            });
            data.push(d)
          });
          this.data=data
        }
      },
      setColumnsAndData() {

        if (this.checkinList.length === 0) {
          this.columns = [];
          this.data = [];
          return
        }
        this.setColumns();
        this.setData()

      },

      // init() {
      //   let ret = {
      //     projectFids: [],
      //     type: 0,
      //     startTime: '',
      //     endTime: '',
      //     page: 1,
      //     limit: 10
      //   }
      //   let p1 = getProjects().then(res => {
      //     if (!res.data) {
      //       return
      //     }
      //     res.data.length > 0 && (ret.projectFids = [res.data[0].value])
      //   }).catch(error => {
      //   }).finally(() => {
      //     let date = new Date()
      //     let year = date.getFullYear()
      //     let month = date.getMonth()
      //     let day = date.getDate()
      //     ret.startTime = formatDateTime(new Date(year, month, day - 7), false)
      //     ret.endTime = formatDateTime(new Date(year, month, day - 1), false)
      //     this.searchData = ret
      //
      //     this.checkinRateList()
      //
      //   })
      // },
      changePage(n) {
        this.current = n;
        this.page = n;
        this.checkinRateList()
      },
      checkinRateList() {
        let params={
          ...this.searchData,
          page:this.page,
          limit:10
        };
        checkinRateList(params).then(res => {
          if(!res.data){
            return
          }
          this.checkinList=res.data.rows;
          this.total=res.data.total

        }).catch(error => {
        }).finally(() => {
          this.setColumnsAndData()
        })

      }
    },

  }
</script>

<style scoped>

</style>
